import React from 'react';
import PropTypes from 'prop-types';
import { Field, Fields } from 'redux-form';

import { intentType } from 'types';

import Toggler from 'components/Toggler';
import { FormGroupTextarea, FormLabel } from 'components/Form';
import FormNamedColorPalette from 'components/Form/components/FormNamedColorPalette';
import ConstraintsConfig from './component/ConstraintsConfig';

import './style.scss';

const GeneralTab = ({ intent, handlersOfNameInputRef }) => {
  const isDisabled = intent.xpack_resource || intent.archived;

  return (
    <div data-item="intent" data-test="general-tab" styleName="intent">
      <FormLabel htmlFor="name">INTENT NAME</FormLabel>
      <div styleName="infos">
        <Fields
          autoFocus
          component={FormNamedColorPalette}
          handlersOfNameInputRef={handlersOfNameInputRef}
          isDisabled={isDisabled}
          names={['color', 'name']}
          placeholder="Please type a name for the intent"
          styleName="color-picker-field"
        />
        <Field
          component={Toggler}
          isDisabled={intent.archived}
          label="Active"
          name="enabled"
          styleName="toggler"
        />
      </div>

      {intent.xpack_resource && <ConstraintsConfig />}

      <Field
        component={FormGroupTextarea}
        data-test="intent-description"
        disabled={isDisabled}
        label="DESCRIPTION"
        name="description"
        placeholder="Intent description"
        styleName="textarea"
        type="textarea"
      />
    </div>
  );
};

GeneralTab.propTypes = {
  intent: intentType.isRequired,
  handlersOfNameInputRef: PropTypes.arrayOf(PropTypes.func),
};

GeneralTab.defaultProps = {
  handlersOfNameInputRef: [],
};

export default GeneralTab;
